var map = {
	"./icon-arrow.svg": 1089,
	"./icon-back.svg": 5460,
	"./icon-copy.svg": 4171,
	"./icon-discord.svg": 9845,
	"./icon-lang.svg": 7667,
	"./icon-menu.svg": 5913,
	"./icon-telegram.svg": 5810,
	"./icon-x.svg": 6989,
	"./icon-youtube.svg": 351
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7933;